import { defineMessages } from 'react-intl';

export default defineMessages({
	externalLinkRequestFormIconLabel: {
		id: 'cv.external-links.link.external-link-request-form-icon-label',
		defaultMessage: 'Request form',
		description: 'Label for Request form external link icon',
	},
	externalLinkKnowledgeIconLabel: {
		id: 'cv.external-links.link.external-link-knowledge-icon-label',
		defaultMessage: 'Knowledge',
		description:
			'The text is shown as an accessible icon label for an external link of type "Knowledge" in the related resources section of a help center portal page.',
	},
	externalLinkHelpChannelIconLabel: {
		id: 'cv.external-links.link.external-link-help-channel-icon-label',
		defaultMessage: 'Help channel',
		description:
			'The text is shown as an accessible icon label for an external link of type "Help channel" in the related resources section of a help center portal page.',
	},
	externalLinkHoverTooltip: {
		id: 'cv.external-links.link.external-link-hover-tooltip',
		defaultMessage: 'Opens in new tab',
		description:
			'The text is shown as a tooltip on an external link item when the user hovers over it, indicating that the link will open in a new browser tab.',
	},
});
